import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import { useParams, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import Sidebar from './Sidebar';
import { Session } from "../components/utils/session";

export default function BoardDetails(props) {
  const params = useParams();
  const location = useLocation();
  const boardId = props.boardId || params.boardId || '';
  const boardName = props.boardName || location.state?.boardName || '';
  const isModal = !!props.isModal;
  const [lists, setLists] = useState([]);
  const [cardsByList, setCardsByList] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(!isModal);
  const [showModal, setShowModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardComments, setCardComments] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [commentsError, setCommentsError] = useState(null);
  const [cardTasks, setCardTasks] = useState([]);
  const [tasksLoading, setTasksLoading] = useState(false);
  const [tasksError, setTasksError] = useState(null);
  const [cardActivity, setCardActivity] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [activityError, setActivityError] = useState(null);

  const token = Session.getToken();
  const currentUserId = Session.getUserId();


  useEffect(() => {
    setLoading(true);
    setError(null);
    const role = Session.getRole && typeof Session.getRole === 'function' ? Session.getRole() : null;
    if (!currentUserId && (!role || role.toLowerCase() !== 'super admin')) {
      setError('User not found. Please login again.');
      setLists([]);
      setCardsByList({});
      setLoading(false);
      return;
    }
    fetch(`${API_BASE_URL}/api/Workspace/board_List?boardId=${boardId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch board lists');
        return res.json();
      })
      .then(async result => {
        const listsData = result && result.data ? result.data : [];
        setLists(listsData);
        const cardsObj = {};
        for (const list of listsData) {
          try {
            let cards = [];
            if (role && role.toLowerCase() === 'super admin') {
              const res = await fetch(`${API_BASE_URL}/api/Cards/Card_details?boardId=${boardId}&listId=${list.listID}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (res.ok) {
                cards = await res.json();
              }
            } else {
              const res = await fetch(`${API_BASE_URL}/api/Cards/by_user?boardId=${boardId}&listId=${list.listID}&userId=${currentUserId}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (res.ok) {
                cards = await res.json();
              }
            }
            console.log(`Cards for list ${list.listID}:`, cards);
            cardsObj[list.listID] = Array.isArray(cards) ? cards : [];
          } catch {
            cardsObj[list.listID] = [];
          }
        }
        setCardsByList(cardsObj);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLists([]);
        setLoading(false);
      });
  }, [boardId, token, currentUserId]);

  useEffect(() => {
    if (showModal && selectedCard) {
      setCommentsLoading(true);
      setCommentsError(null);
      fetch(`${API_BASE_URL}/api/Cards/${selectedCard.cardID}/comments`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch comments');
          return res.json();
        })
        .then(data => {
          setCardComments(data || []);
          setCommentsLoading(false);
        })
        .catch(err => {
          setCommentsError(err.message);
          setCardComments([]);
          setCommentsLoading(false);
        });

      // Fetch tasks for the card
      setTasksLoading(true);
      setTasksError(null);
      fetch(`${API_BASE_URL}/api/Cards/Task/${selectedCard.cardID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch tasks');
          return res.json();
        })
        .then(data => {
          setCardTasks(Array.isArray(data) ? data : []);
          setTasksLoading(false);
        })
        .catch(err => {
          setTasksError(err.message);
          setCardTasks([]);
          setTasksLoading(false);
        });

      // Fetch activity for the card
      setActivityLoading(true);
      setActivityError(null);
      fetch(`${API_BASE_URL}/api/Cards/${selectedCard.cardID}/activity`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch activity');
          return res.json();
        })
        .then(data => {
          setCardActivity(Array.isArray(data) ? data : []);
          setActivityLoading(false);
        })
        .catch(err => {
          setActivityError(err.message);
          setCardActivity([]);
          setActivityLoading(false);
        });
    } else {
      setCardComments([]);
      setCommentsError(null);
      setCardTasks([]);
      setTasksError(null);
      setCardActivity([]);
      setActivityError(null);
    }
  }, [showModal, selectedCard, token]);



  return (
    <div style={{ display: 'flex' }}>
      {sidebarOpen && (
        <div id="sidebar" style={{ minWidth: 250 }}>
          <Sidebar />
        </div>
      )}
      <div id="content" style={{ flex: 1, padding: 20, marginLeft: 0 }}>
        {!isModal && (
          <div className="d-flex align-items-center mb-3">
            {/* <button
              type="button"
              className="btn btn-toggle me-3"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <i className="fas fa-bars" />
            </button> */}
            {/* <button
              type="button"
              className="text-muted text-decoration-none small btn btn-link p-0"
              style={{ boxShadow: 'none' }}
              onClick={() => navigate('/dailytask')}
            >
              <i className="fas fa-chevron-left" /> Back
            </button> */}
          </div>
        )}
        {/* <h2>Board Details (ID: {boardId})</h2> */}
        <div className="main-card mt-4">
          <h5 className="fw-bold mb-3">Board : {boardName}</h5>
          <div>
            <div className="trello-board-page">
              {loading && <div className="trello-loading">Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              <div className="trello-board-lists">
                {lists
                  .filter(list => cardsByList[list.listID] && cardsByList[list.listID].length > 0)
                  .map(list => (
                    <div className="trello-list" key={list.listID}>
                      <div className="trello-list-title">{list.listName}</div>
                      <div className="trello-cards">
                        {cardsByList[list.listID].map(card => (
                          <div
                            className="trello-card"
                            key={card.cardID}
                            onClick={() => {
                              setSelectedCard(card);
                              setShowModal(true);
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="trello-card-title">{card.cardTitle}</div>
                          </div>
                        ))}
                        {showModal && selectedCard && (
                          <div
                            style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              backgroundColor: 'rgba(0, 0, 0, 0.18)',
                              width: '100vw',
                              height: '100vh',
                              zIndex: 9999,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={() => setShowModal(false)}
                          >
                        <div style={{
                            margin: '0 auto',
                            boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
                            borderRadius: 12,
                            background: '#f4f5f7',
                            width: '60%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                             {/* Close Button */}
                              <button
                                style={{
                                  background: '#fff',
                                  border: 'none',
                                  fontSize: 28,
                                  borderRadius: '12px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'end',
                                  padding: '0px 16px',
                                }}
                                onClick={() => setShowModal(false)}
                                aria-label="Close"
                              >
                                &times;
                              </button>
                        <div
                              style={{
                                background: '#fff',
                                borderRadius: 12,
                                width: '100%',
                                maxWidth: '98vw',
                                minHeight: '600px',
                                boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
                                display: 'flex',
                                flexDirection: 'row',
                                position: 'relative',
                              }}
                              onClick={e => e.stopPropagation()}
                            >
                          
                              {/* Left: Card Details */}
                              <div style={{ flex: 2, padding: '32px 24px 24px 32px', borderRight: '1px solid #eee', 
                                maxHeight: '600px', overflowY: 'auto' }}>
                                <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>
                                  {selectedCard.cardTitle}
                                </div>
                                {selectedCard.assignedUserName && (
                                  <div style={{ fontSize: 15, color: '#4257b2', fontWeight: 500, marginBottom: 16 }}>
                                    Assigned to: {selectedCard.assignedUserName}
                                  </div>
                                )}
                                <div style={{ marginBottom: 24 }}>
                                  <label style={{ fontWeight: 600, marginBottom: 8, display: 'block' }}>Description</label>

                                  {selectedCard.description ? (
                                    <div
                                      style={{ whiteSpace: 'normal' }}
                                      dangerouslySetInnerHTML={{ __html: marked.parse(selectedCard.description) }}
                                    />
                                  ) : (
                                    <span style={{ color: '#aaa' }}>No description</span>
                                  )}
                                  <div style={{ marginBottom: 24 }}>
                                    <label style={{ fontWeight: 600, marginBottom: 8, display: 'block' }}>Task</label>
                                    <div style={{ background: '#f4f5f7', borderRadius: 8, padding: 16, border: '1px solid #e4e6ea', marginBottom: 8 }}>
                                      {tasksLoading && (
                                        <div style={{ color: '#888', fontSize: 14 }}>Loading tasks...</div>
                                      )}
                                      {tasksError && (
                                        <div style={{ color: 'red', fontSize: 14 }}>{tasksError}</div>
                                      )}
                                      {!tasksLoading && !tasksError && cardTasks.length === 0 && (
                                        <div style={{ color: '#888', fontSize: 14 }}>No tasks/checklist available.</div>
                                      )}
                                      {!tasksLoading && !tasksError && Array.isArray(cardTasks) && cardTasks.length > 0 && (
                                        <>
                                          {/* Progress bar and actions */}
                                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                            <span style={{ fontWeight: 600, fontSize: 15, marginRight: 12 }}>
                                              {(() => {
                                                // Calculate total items and completed items
                                                let total = 0, completed = 0;
                                                cardTasks.forEach(cl => {
                                                  if (Array.isArray(cl.items)) {
                                                    total += cl.items.length;
                                                    completed += cl.items.filter(i => i.isCompleted).length;
                                                  }
                                                });
                                                return total > 0 ? Math.round((completed / total) * 100) : 0;
                                              })()}%
                                            </span>
                                            <div style={{ flex: 1, height: 8, background: '#e4e6ea', borderRadius: 6, marginRight: 12, position: 'relative' }}>
                                              <div style={{
                                                width: `${(() => {
                                                  let total = 0, completed = 0;
                                                  cardTasks.forEach(cl => {
                                                    if (Array.isArray(cl.items)) {
                                                      total += cl.items.length;
                                                      completed += cl.items.filter(i => i.isCompleted).length;
                                                    }
                                                  });
                                                  return total > 0 ? (completed / total) * 100 : 0;
                                                })()}%`,
                                                height: '100%',
                                                background: '#61bd4f',
                                                borderRadius: 6,
                                                transition: 'width 0.3s',
                                              }} />
                                            </div>
                                            <button style={{ fontSize: 13, background: '#f4f5f7', border: '1px solid #e4e6ea', borderRadius: 6, padding: '2px 10px', marginRight: 6, cursor: 'pointer' }}>
                                              Hide checked items
                                            </button>
                                            <button style={{ fontSize: 13, background: '#f4f5f7', border: '1px solid #e4e6ea', borderRadius: 6, padding: '2px 10px', cursor: 'pointer' }}>
                                              Delete
                                            </button>
                                          </div>
                                          {/* Checklist groups and items */}
                                          <div style={{ overflowY: 'auto', marginBottom: 8 }}>
                                            {cardTasks.map((cl, cidx) => (
                                              <div key={cl.checklistID || cidx}>
                                                <div style={{ fontWeight: 600, fontSize: 15, margin: '10px 0 4px 0', color: '#222', letterSpacing: 0.5 }}>
                                                  {cl.checklistTitle || 'Checklist'}
                                                </div>
                                                {Array.isArray(cl.items) && cl.items.map((item, iidx) => (
                                                  <div key={item.checklistItemID || iidx} style={{ display: 'flex', alignItems: 'center', marginBottom: 6, marginLeft: 18 }}>
                                                    <input type="checkbox" checked={!!item.isCompleted} readOnly style={{ marginRight: 10, accentColor: '#61bd4f', width: 18, height: 18 }} />
                                                    <span style={{
                                                      textDecoration: item.isCompleted ? 'line-through' : 'none',
                                                      color: item.isCompleted ? '#888' : '#222',
                                                      fontSize: 15,
                                                      flex: 1,
                                                    }}>
                                                      {item.itemName || 'Untitled Task'}
                                                    </span>
                                                  </div>
                                                ))}
                                              </div>
                                            ))}
                                          </div>
                                          <button style={{ fontSize: 14, background: '#fff', border: '1px solid #e4e6ea', borderRadius: 6, padding: '6px 16px', color: '#4257b2', fontWeight: 500, cursor: 'pointer', marginTop: 4, width: 'fit-content' }}>
                                            Add an item
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div style={{ flex: 1.9, padding: '32px 24px 24px 24px', background: '#fafbfc', height: '600px', 
                                maxHeight: '600px', overflowY: 'auto', borderRadius: '0 12px 12px 0' }}>
                                <div style={{ fontWeight: 600, marginBottom: 16 }}>Comments and activity</div>
                                {commentsLoading && (
                                  <div style={{ color: '#888', marginBottom: 16 }}>Loading comments...</div>
                                )}
                                {commentsError && (
                                  <div style={{ color: 'red', marginBottom: 16 }}>{commentsError}</div>
                                )}
                                {!commentsLoading && !commentsError && cardComments.length === 0 && (
                                  <div style={{ fontWeight: 500, color: '#555', marginBottom: 16 }}>No comments yet.</div>
                                )}
                                {!commentsLoading && !commentsError && cardComments.length > 0 && (
                                  <div>
                                    {cardComments.map((comment, idx) => {
                                      const name = comment.userName || comment.authorName || comment.username || comment.user || 'User';
                                      const initials = name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
                                      const createdAt = comment.createdAt ? new Date(comment.createdAt) : null;
                                      return (
                                        <div key={comment.commentID || idx} style={{ marginBottom: 22, background: '#fff', 
                                        borderRadius: 10, boxShadow: '0 1px 2px rgba(0,0,0,0.04)', border: '1px solid #e4e6ea', padding: '16px 8px' }}>
                                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                            {/* Avatar */}
                                            <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#e2e4ea', color: '#4257b2', fontWeight: 700, fontSize: 17, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 12, flexShrink: 0 }}>
                                              {initials}
                                            </div>
                                            <span style={{ fontWeight: 600, color: '#172b4d', fontSize: 15 }}>{name}</span>
                                            {createdAt && (
                                              <button
                                                type="button"
                                                style={{ color: '#4257b2', background: 'none', border: 'none', padding: 0, fontSize: 12, marginLeft: 10, textDecoration: 'underline', fontWeight: 400, cursor: 'pointer' }}
                                                tabIndex={-1}
                                                aria-label="Created at"
                                                disabled
                                              >
                                                {createdAt.toLocaleString()}
                                              </button>
                                            )}
                                          </div>
                                          <div style={{ fontSize: 15, color: '#444', whiteSpace: 'pre-line', marginBottom: 6 }}>
                                            {comment.text || comment.commentText ? (
                                              <div
                                                style={{ whiteSpace: 'normal' }}
                                                dangerouslySetInnerHTML={{ __html: marked.parse(comment.text || comment.commentText) }}
                                              />
                                            ) : ''}
                                          </div>
                                          {/* Action links */}
                                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 13, color: '#6b778c', marginLeft: 2 }}>
                                            <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>Edit</span>
                                            <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>Delete</span>
                                            <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>Add link as attachment</span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}

                                {/* Card Activity Section */}
                                
                                {activityLoading && (
                                  <div style={{ color: '#888', marginBottom: 16 }}>Loading activity...</div>
                                )}
                                {activityError && (
                                  <div style={{ color: 'red', marginBottom: 16 }}>{activityError}</div>
                                )}
                                {!activityLoading && !activityError && cardActivity.length === 0 && (
                                  <div style={{ fontWeight: 500, color: '#555', marginBottom: 16 }}>No activity yet.</div>
                                )}
                                {!activityLoading && !activityError && cardActivity.length > 0 && (
                                  <div>
                                    {cardActivity.map((activity, idx) => {
                                      const name = activity.userName || activity.authorName || activity.username || activity.user || 'User';
                                      let initials = '';
                                      if (name.trim().includes(' ')) {
                                        initials = name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
                                      } else {
                                        initials = name.substring(0, 2).toUpperCase();
                                      }
                                      const createdAt = activity.createdAt ? new Date(activity.createdAt) : null;
                                      const activityText = activity.activityDescription || activity.text || activity.activityText || activity.description || '';
                                      return (
                                        <div key={activity.activityID || idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 12, padding: '4px 0' }}>
                                          {/* Avatar */}
                                          <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#e2e4ea', color: '#4257b2', fontWeight: 700, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, flexShrink: 0 }}>
                                            {initials}
                                          </div>
                                          <div style={{ flex: 1, minWidth: 0 }}>
                                            <span style={{ fontWeight: 600, color: '#172b4d', fontSize: 15 }}>{name}</span>
                                            {activityText && <span style={{ fontWeight: 400, color: '#444', marginLeft: 6 }}>{activityText}</span>}
                                            <div>
                                              {createdAt && (
                                                <button
                                                  type="button"
                                                  style={{ color: '#1976d2', background: 'none', border: 'none', fontSize: 13, marginTop: 2, display: 'inline-block', textDecoration: 'underline', fontWeight: 400, cursor: 'pointer' }}
                                                  tabIndex={-1}
                                                  aria-label="Created at"
                                                  disabled
                                                >
                                                  {createdAt.toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          
                        </div>
                            
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                <div className="trello-list trello-add-list">
                  <button className="btn btn-outline-primary w-100">
                    <i className="fas fa-plus"></i> Add another list
                  </button>
                </div>
              </div>
              <style>{`
        .trello-board-page {
          padding: 24px 8px 8px 8px;
          background: #f4f5f7;
          // min-height: 100vh;
        }
        .trello-board-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 24px;
        }
        .trello-board-title {
          font-size: 2rem;
          font-weight: 700;
          color: #333;
        }
        .trello-board-lists {
          display: flex;
          flex-wrap: nowrap;
          gap: 24px;
          overflow-x: auto;
          padding-bottom: 16px;
        }
        .trello-list {
          background: #ebecf0;
          border-radius: 10px;
          min-width: 300px;
          max-width: 320px;
          padding: 16px 12px 12px 12px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          max-height: 70vh;
          overflow: auto;
        }
        .trello-list-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 12px;
          color: #172b4d;
        }
        .trello-cards {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .trello-card {
          background: #fff;
          border-radius: 6px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.07);
          padding: 12px 10px;
          font-size: 1rem;
          color: #333;
          transition: box-shadow 0.2s;
          cursor: pointer;
        }
        .trello-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.13);
        }
        .trello-no-cards {
          color: #888;
          font-size: 0.95rem;
          padding: 8px 0;
        }
        .trello-add-list {
          background: transparent;
          box-shadow: none;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        }
        @media (max-width: 900px) {
          .trello-board-lists {
            gap: 12px;
          }
          .trello-list {
            min-width: 220px;
            max-width: 240px;
            padding: 10px 6px 8px 6px;
          }
        }
        @media (max-width: 600px) {
          .trello-board-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }
          .trello-board-title {
            font-size: 1.9rem;
          }
          .trello-list {
            min-width: 160px;
            max-width: 180px;
            padding: 7px 3px 6px 3px;
          }
        }
      `}</style>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
